import React, { useState, useEffect } from "react";
import CloseIcon from "../../../assets/crossIcon.svg";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const EditStatusClaimModal = ({
  setEditStatus,
  caseId,
  caseDetails,
  AllCases,
}) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [documents, setDocuments] = useState(null);
  // const [caseStatus, setCaseStatus] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const [claimPaidAmount, setClaimPaidAmount] = useState(null);
  const [tdsAmount, setTdsAmount] = useState(null);
  const [claimId, setClaimId] = useState(null);
  const [utrNo, setUtrNo] = useState(null);
  const [packageAmount, setPackageAmount] = useState(null);
  const [adjustedPackageAmount, setAdjustedPackageAmount] = useState(null);
  const [payableAmount, setPayableAmount] = useState(null);
  const [eRupiAmount, setErupiAmount] = useState(null);
  const [miscellaneousAmount, setMiscellaneousAmount] = useState(null);
  const [transactionDate, setTransactionDate] = useState(null);
  const [costDetails, setCostDetails] = useState(null);
  const [rejectDocs, setRejectDocs] = useState(false);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [dischargeDetails, setDischargeDetails] = useState(null);
  const currentRole = useSelector((state) => state.currentRole.value);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    const errors = {};

    if (
      packageAmount === null ||
      packageAmount === undefined ||
      packageAmount === ""
    ) {
      errors.packageAmount = true;
    }

    if (
      adjustedPackageAmount === null ||
      adjustedPackageAmount === undefined ||
      adjustedPackageAmount === ""
    ) {
      errors.adjustedPackageAmount = true;
    }

    if (
      payableAmount === null ||
      payableAmount === undefined ||
      payableAmount === ""
    ) {
      errors.payableAmount = true;
    }

    if (!claimId || !claimId.trim()) {
      errors.claimId = true;
    }

    if (
      claimPaidAmount === null ||
      claimPaidAmount === undefined ||
      claimPaidAmount === ""
    ) {
      errors.claimPaidAmount = true;
    }

    if (!transactionDate) {
      errors.transactionDate = true;
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);

      const missingFields = [];

      if (errors.packageAmount) {
        missingFields.push("Total Package Amount (without incentives)");
      }

      if (errors.adjustedPackageAmount) {
        missingFields.push("Total Adjusted Package Amount as per Guidelines");
      }

      if (errors.payableAmount) {
        missingFields.push("Total Payable Amount after Incentives");
      }

      if (errors.claimId) {
        missingFields.push("Claim ID");
      }

      if (errors.claimPaidAmount) {
        missingFields.push("Claim Paid Amount");
      }

      if (errors.transactionDate) {
        missingFields.push("Claim Paid Date & Time");
      }

      window.alert(
        `Please fill the following mandatory field(s):\n\n${missingFields.join("\n")}`,
      );
      return;
    }

    setValidationErrors({});
    setSubmitting(true);

    const subMasterStageData = {
      hsaStage: "Claim Paid",
      commandCeneterStage: "Claim Amount Paid by Bank on TMS",
      nextStepUser: "NA",

      caseDetails: [
        {
          query: "",
          queryResponse: "",
        },
      ],
    };

    const caseMasterDetailsData = [
      {
        detailType: "CLAIM",
        caseId: documents?.currnetSubMasterStage[0]?.caseId,
        status: 9,
        // id: dischargeDetails?.id,
        details: {
          totalPackageAmount: packageAmount,
          totalAdjustedPackageAmount: adjustedPackageAmount,
          totalPayableAmount: payableAmount,
          eRupiAmount: eRupiAmount,
          miscellaneousAmount: miscellaneousAmount,
          paymentStatus: paymentStatus,
          remarks: remarks,
          utrNo: utrNo,
          claimId: claimId,
          claimPaidAmount: claimPaidAmount,
          tdsAmount: tdsAmount,
          transactionDate: new Date(transactionDate).toISOString(),
        },
      },
    ];

    try {
      await CaseServices.addEnhancement(caseMasterDetailsData);

      const stageResponse = await CaseServices.updateSubMasterStage(
        documents?.documents[0]?.caseId,
        subMasterStageData,
      );

      window.alert(stageResponse.data.message);
      setEditStatus(false);
      AllCases && (await AllCases());
      navigate("/dashboard/ActiveCases");
    } catch (error) {
      handleApiErrorResponses(error);
    }

    setSubmitting(false);
  };
  const handleRejection = async () => {
    setSubmitting(true);
    let data = documents.documents.filter((doc) => doc.isSelected);
    data = data.map((document) => {
      return {
        id: document.id,
        status: "REJECTED",
        rejectionReason: rejectionReason,
      };
    });
    try {
      if (rejectionReason) {
        const response = await CaseServices.updateMultipleDocumentStatus(
          data,
          currentRole?.role?.roleName,
        );
        window.alert(response.data.message);
        navigate("/dashboard/ActiveCases");
      } else {
        window.alert("Rejection Reason is Required");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSubmitting(false);
  };
  const handleSelection = (idx) => {
    const modifiedData = documents?.documents?.map((document, index) => {
      if (idx === index) {
        return { ...document, isSelected: !document.isSelected };
      } else {
        return document;
      }
    });
    const filteredData = modifiedData.filter((document) => document.isSelected);
    if (filteredData.length > 0) {
      setRejectDocs(true);
    } else {
      setRejectDocs(false);
    }
    documents.documents = modifiedData;
    setDocuments(documents);
  };
  const getDocumentDetails = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(caseId);
      const modifiedData = response.data?.documents?.map((document, idx) => {
        return { ...document, isSelected: false };
      });
      response.data.documents = modifiedData;
      setDocuments(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDischarge = async () => {
    try {
      const response = await CaseServices.getDischarge(caseId);
      setDischargeDetails(response?.data?.dischargeDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getCostDetails = async () => {
    try {
      const response = await CaseServices.getCaseCostDetails(caseId);
      setCostDetails(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getDocumentDetails();
    getCostDetails();
    getDischarge();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={{
        maxHeight: "85%",
        background: "white",
        position: "relative",
        border: "1px solid #E4E4E4",
        borderRadius: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="w-[80%] xl:w-[80%] xl:p-16"
    >
      <div
        style={{
          position: "absolute",
          top: "28px",
          right: "32px",
          cursor: "pointer",
        }}
        onClick={() => setEditStatus(false)}
      >
        <img src={CloseIcon} height={30} width={30} alt="close-icon" />
      </div>
      <div className="w-full">
        <div>
          <div className="text-[#191919] text-center text-xl 2xl:text-2xl font-semibold">
            Change case status
          </div>
          <div className="text-[#797979] text-sm 2xl:text-base text-center">
            This is the current case status
          </div>
          <div className="text-[#191919] text-sm 2xl:text-base text-center font-semibold">
            {documents?.currnetSubMasterStage[0].commandCenterStage}
          </div>
        </div>
        <div className="mt-4 w-full flex justify-center pb-4 xl:pb-0">
          <div className="w-[100%] overflow-y-scroll h-[400px] pr-2">
            {/* <div className="border border-solid border-[#e5e5e5] p-4 rounded-[16px] my-5">
              <div>
                <div className="text-[18px] font-semibold">Procedures:</div>
                <div className="flex items-center gap-5 px-4">
                  {costDetails?.procedures?.map((procedure, idx) => {
                    return (
                      <div key={idx}>
                        <div className="text-[#191919] font-medium flex justify-between">
                          {`Procedure ${idx + 1} Cost:`}
                          <span className="text-[#797979] font-normal">
                            ₹{procedure.packageCost}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div>
                <div className="text-[18px] font-semibold">Enhancements:</div>

                <div className=" flex items-center gap-5 mt-1 px-5">
                  {costDetails?.enhancements?.map((enhancement, idx) => {
                    return (
                      <div key={idx}>
                        <div className="text-[#191919] font-medium flex justify-between">
                          Enhancement {idx + 1} Cost
                          {": "}
                          <span className="text-[#797979] font-normal">
                            ₹{enhancement?.details?.cost}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="mt-1">
                <div>
                  <div className="text-[#191919] font-semibold flex gap-5">
                    Total Package Cost
                    {": "}
                    <span className="text-[#797979] font-normal">
                      ₹{costDetails?.caseDetails?.totalPackageCost}
                    </span>
                  </div>
                </div>
              </div>
            </div> */}

            {rejectDocs && (
              <div className="w-full">
                <div className="text-red-500 font-bold mt-2">
                  Selected Documents will be Rejected*
                </div>

                <textarea
                  rows="5"
                  placeholder="Rejection Reason"
                  style={{ border: "1px solid #E4E4E4" }}
                  className="w-full  rounded-[8px] p-3 mt-2"
                  onChange={(e) => setRejectionReason(e.target.value)}
                />
                <div className="flex justify-center mt-2">
                  {isSubmitting ? (
                    <CircularProgress />
                  ) : (
                    <div
                      style={{ border: "1px solid #017C57" }}
                      className="text-sm font-semibold text-[#017C57] bg-white px-8 py-2 uppercase rounded-full cursor-pointer"
                      onClick={handleRejection}
                    >
                      Reject
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="border border-solid border-[#e5e5e5] p-4 rounded-[16px] my-5">
              <div className="text-xl font-semibold">
                Amount and Incentive Details
              </div>
              <div className="w-[100%] text-sm 2xl:text-base mt-5 space-y-1 grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 xl:gap-x-2 items-center ">
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="packageAmount"
                    placeholder="Enter total package amount without incentives *"
                    value={packageAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setPackageAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="adjustedPackageAmount"
                    placeholder="Enter total adjusted package amount as per guidelines *"
                    value={adjustedPackageAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setAdjustedPackageAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="payableAmount"
                    placeholder="Enter total payable amount after incentives *"
                    value={payableAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setPayableAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="eRupiAmount"
                    placeholder="Enter e-RUPI amount"
                    value={eRupiAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setErupiAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="miscelleneousAmount"
                    placeholder="Enter miscelleneous amount"
                    value={miscellaneousAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setMiscellaneousAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="border border-solid border-[#e5e5e5] p-4 rounded-[16px]">
              <div className="text-xl font-semibold">Payment Details</div>
              <div className="w-[100%] text-sm 2xl:text-base mt-5 space-y-1 grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 xl:gap-x-2 items-center ">
                {/* <select
                  name="caseStatus"
                  id=""
                  style={{ border: "1px solid #E4E4E4" }}
                  className=" w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                  onChange={(e) => setCaseStatus(e.target.value)}
                >
                  <option value="">Select Case Status</option>
                  <option value="claim undersettled">
                    Claim Under Settled
                  </option>
                  <option value="claim settled">Claim Settled</option>
                </select> */}
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    placeholder="Enter Payment Status"
                    value={paymentStatus}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setPaymentStatus(e.target.value)}
                  />
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    placeholder="Enter Remarks"
                    value={remarks}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    placeholder="Enter UTR No."
                    value={utrNo}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setUtrNo(e.target.value)}
                  />
                </div>

                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    placeholder="Enter Claim ID *"
                    value={claimId}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setClaimId(e.target.value)}
                  />
                </div>

                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="amount"
                    placeholder="Enter claim paid amount *"
                    value={claimPaidAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setClaimPaidAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>

                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="number"
                    name="tds-amount"
                    placeholder="Enter TDS amount"
                    value={tdsAmount}
                    className="outline-none appearance-none border-0 w-[100%]  h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setTdsAmount(e.target.value)}
                  />
                  <div className="absolute h-full top-[0] right-[12px] flex items-center z-10 ">
                    <div className="underline-offset-1 text-xs font-semibold text-[#BCBCBC]">
                      In ₹
                    </div>
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #E4E4E4" }}
                  className="relative rounded-[8px] w-[100%]"
                >
                  <input
                    type="datetime-local"
                    placeholder="Enter Transaction Date *"
                    value={transactionDate}
                    className="outline-none appearance-none border-0 w-[100%] h-full rounded-[8px] py-[10px] px-3"
                    onChange={(e) => setTransactionDate(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {!rejectDocs && (
              <div className="flex justify-center mt-8">
                {isSubmitting ? (
                  <CircularProgress />
                ) : (
                  <div
                    style={{ border: "1px solid #017C57" }}
                    className="w-fit text-xs font-semibold text-[#017C57] rounded-full px-6 py-2 cursor-pointer"
                    onClick={handleSubmit}
                  >
                    CHANGE STATUS
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* current stage documents */}
    </div>
  );
};

export default EditStatusClaimModal;
